import { render } from "./ChartBp.vue?vue&type=template&id=ca25d4ba"
import script from "./ChartBp.vue?vue&type=script&lang=js"
export * from "./ChartBp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__